/**
 * Getters for chat
 */
export const getters = {
  getEmails(state) {
    return state.emails;
  },

  getUnreadMailIds(state) {
    return state.unreadMailIds;
  },

  getFavouriteMode(state) {
    return state.favouriteMode;
  },

  getBoxCount(state) {
    return state.boxCount;
  },

  getSelectedCustomFolderName(state) {
    return state.selectedCustomFolderName;
  },

  getInitialMailDetails(state) {
    return state.initialMailDetail;
  },

  getComposeEmailLoading(state) {
      return state.composeEmailLoading;
  },

  getContactList(state) {
    return state.contactList;
  },

  getEmailFolder(state) {
    return state.emailFolder;
  },

  getSignatures(state) {
    return state.signatures;
  },

  getSelectedUserId(state) {
    return state.selectedUserId;
  },

  getSubscriberId(state) {
    return state.subscriberId;
  },

  getAppUsers(state) {
    return state.appUsers;
  },

  getUnreadMailCountOnOtherPage(state) {
    return state.unreadMailCountOnOtherPage;
  }
};
